import React from 'react';
import { jumpTo } from '@/navigate'
import './index.scss';
import loader from '../three/loader';

class App extends React.Component {
    state = {}
    componentDidMount(){
        loader.loadImageAnim();
    }
    render() {
        return (
            <div className="page page-guide guide">
                <div className="logoBox">
                    <img src={require('../../assets/images/logo_1.png')} alt="" className="logoBox-img1" />
                    <span className="logoBox-split"></span>
                    <img src={require('../../assets/images/logo_2.png')} alt="" className="logoBox-img2" />
                    <span className="logobox-txt">针灸推拿学院/第三附属医院</span>
                </div>
                <div className="titleBox">
                    针灸适宜病症诊疗思维与<br />
                    技能交互训练
                </div>
                <div className="button nextBtn" onClick={() => jumpTo('guide2')}>
                    <span>进入课程</span>
                    <img src={require('../../assets/images/right.png')} />
                </div>
            </div>
        );
    }
}

export default App;
